<template>
  <div class="header-container">
    <div class="header container">
      <div class="main" v-if="isPc == 1">
        <!-- <div class="justify-between">
          <div></div>
          <router-link :to="{ path: '/' }">
            <div class="logo-title items-end">
              <img src="@/assets/images/logow.png" style="width:100px;height:70px;">
              <h3>台商雜誌</h3>
            </div>
          </router-link>
          <div class="icons justify-center items-center">
            <a href="https://www.facebook.com/TS960/" target="blank" class="items-center justify-center">
              <svg-icon icon-class="Group 4726"></svg-icon>
            </a>
            <a href="https://www.youtube.com/channel/UCHiVD1zjXzBs0XvhTu5b3pA" target="blank"
              class="items-center justify-center">
              <svg-icon icon-class="Group 4728"></svg-icon>
            </a>
            <a :href="'tel:' + webInfo.phone" class="items-center justify-center">
              <svg-icon icon-class="Group 4725"></svg-icon>
            </a>
            <div class="btn bg-red2 justify-center items-center">
              <svg-icon icon-class="search-red"></svg-icon>
            </div>
            未登录/已登录
            <div v-if="!validToken" class="btn bg-red justify-center items-center" @click="dialogVisible = true">
              <svg-icon icon-class="login-red"></svg-icon>
            </div>
            <div v-else class="btn bg-red btn-maz justify-center items-center" @click="toMyCenter">
              <svg-icon icon-class="magazine"></svg-icon>
            </div>
          </div>
        </div> -->
        <div class="menu justify-between items-center">
          <router-link :to="{ path: '/' }">
            <img src="@/assets/images/logo.png" style="width:100px;height:70px;">
          </router-link>

          <el-menu :default-active="onRoutes" class="el-menu-demo" mode="horizontal" @select="handleSelect"
            background-color="#fff" text-color="#2C2C2E" active-text-color="#2C2C2E">
            <el-menu-item v-for="(item, index) in navMenu" :key="item.title" :index="item.to" :route="`${item.to}`">
              <span>
                {{ item.title }}
              </span>
            </el-menu-item>
            <div class="link-list flex-row justify-center items-center">
              <a href="https://www.facebook.com/TS960/" target="blank" class="items-center justify-center">
                <svg-icon color="#2C2C2E" hover-color="#0666FF" icon-class="facebook"></svg-icon>
              </a>
              <el-popover style="font-size: 0;" placement="bottom" width="200" trigger="hover">
                <div class="wx-popover-content">
                  <img src="@/assets/images/qcode/wx.jpg" style="width: 100%;height: 100%;">
                </div>
                <svg-icon slot="reference" color="#2C2C2E" hover-color="#34C759" icon-class="wx"></svg-icon>

              </el-popover>
              <!-- <a href="http://weixin.qq.com/r/13WHn6XEG-hkreH89yDF" target="blank" class="items-center justify-center">
                <svg-icon color="#2C2C2E" hover-color="#34C759" icon-class="wx"></svg-icon>
              </a> -->
            </div>

          </el-menu>
          <div class="icons justify-center items-center">
            <div class="btn  justify-center items-center" @click="toSearch">
              <svg-icon icon-class="search" color="#2C2C2E" hover-color="#E2291E"></svg-icon>
            </div>
            <div v-if="!validToken" class="btn login-btn justify-center items-center" @click="dialogVisible = true">
              登入
            </div>
            <div v-else class="justify-center items-center">
              <svg-icon icon-class="cart-black" @click="toCart"></svg-icon>
              <el-popover class="my-center-popover" placement="bottom" width="120" trigger="hover">
                <div class="my-center-popover-content">
                  <div class="my-center-popover-item" @click="toMyCenter(1)">
                    <span>{{ L('台商月刊') }}</span>
                  </div>
                  <div class="my-center-popover-item" @click="toMyCenter(2)">
                    <span>{{ L('我的好书') }}</span>
                  </div>
                  <div class="my-center-popover-item" @click="toMyCenter(3)">
                    <span>{{ L('订单记录') }}</span>
                  </div>
                  <div class="my-center-popover-item" @click="logout">
                    <span>{{ L('退出登录') }}</span>
                  </div>
                </div>

                <svg-icon slot="reference" icon-class="my"></svg-icon>
              </el-popover>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="info-list container font14 bg-red items-center justify-center" v-if="newsListRes.length > 0">
      <div class="tag text-red items-center justify-center">
        <span class="bg-white">重點消息</span>
      </div>
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="item in newsListRes" :key="item.newsId">
          <div class="info-list-item text-white hand" @click="toDetails(item.newsId)">
            {{ item.newsTitle }}
          </div>
        </swiper-slide>
      </swiper>
    </div> -->
      <div class="mobile " v-if="isPc != 1">
        <div class="justify-between items-center">
          <router-link :to="{ path: '/' }">
            <div class="logo-title items-center">
              <img src="@/assets/images/logo.png" style="width:52px;height:36px;">
              <!-- <h3>台商雜誌</h3> -->
            </div>
          </router-link>
          <div class="icons justify-center items-center">
            <div class="magazine-card">
              <div class="magazine-card-content" @click="toOrder">
                {{ L('杂志订阅') }}
              </div>
            </div>
            <div class="btn flex-col justify-center items-center" @click="toSearch">
              <svg-icon icon-class="search"></svg-icon>
              <!-- <span class="text-white font12">搜尋</span> -->
            </div>
            <!-- 未登录 -->

            <div v-if="!validToken" class="btn flex-col justify-center items-center" @click="dialogVisible = true">
              <!-- <svg-icon icon-class="login"></svg-icon> -->
              <span class=" font12"> 登入</span>
            </div>
            <!-- 已登录 -->
            <div v-else class=" flex-col btn-maz justify-center items-center" @click="toMyCenter(1)">
              <svg-icon icon-class="my"></svg-icon>
              <!-- <span class="text-white font12">會員中心</span> -->
            </div>
            <div class="menu justify-center items-center " @click="changeDrawer">
              <svg-icon :icon-class="drawer ? 'close' : 'menu'" color="#2C2C2E"></svg-icon>
            </div>
          </div>
        </div>
        <el-drawer title="" append-to-body :visible.sync="drawer" direction="ttb">
          <el-menu :default-active="onRoutes" class="el-menu-demo" router @select="handleSelect" text-color="#2C2C2E"
            active-text-color="#E2291E">
            <el-row>
              <el-col :span="8" v-for="(item, index) in navMobileMenu" :key="item.title">
                <el-menu-item :index="item.to" :route="`${item.to}`">
                  <!-- index为 1,4,7,10的时候加上 class -->
                  <span :class="{ 'border-side': [1, 4, 7, 10].includes(index) }">{{ item.title }}</span>
                </el-menu-item>
              </el-col>
            </el-row>

          </el-menu>
          <div class="menu-bottom">
            <h4>{{ L('台商杂志媒体矩阵：') }}</h4>
            <div class="share justify-between items-center">
              <a href="https://www.facebook.com/TS960/" target="blank" class="items-center justify-center">
                <svg-icon icon-class="facebook" color="#636366" hover-color="#2C2C2E"></svg-icon>
              </a>
              <!-- <a href="http://weixin.qq.com/r/13WHn6XEG-hkreH89yDF" target="blank" class="items-center justify-center"> -->
              <div class="wx-mobile items-center" @click="wxMobile">
                <svg-icon icon-class="wx" color="#636366" hover-color="#2C2C2E"></svg-icon>
              </div>
              <!-- </a> -->

              <a href="https://www.youtube.com/channel/UCHiVD1zjXzBs0XvhTu5b3pA" target="blank"
                class="items-center justify-center">
                <svg-icon icon-class="youtube" color="#636366" hover-color="#2C2C2E"></svg-icon>
              </a>
              <a href="https://weibo.com/u/1890106622" target="blank" class="items-center justify-center">
                <svg-icon icon-class="wb" color="#636366" hover-color="#2C2C2E"></svg-icon>
              </a>
              <a href="https://www.toutiao.com/c/user/token/MS4wLjABAAAA2nDgbCE4iGqok4SR_nWRK2d5Dro0O-ceo9w3DdnjSkE/"
                target="blank" class="items-center justify-center" @mouseenter="hoverIcon('tt')"
                @mouseleave="hoverIcon('tt')">
                <svg-icon icon-class="tt" color="#636366"></svg-icon>
              </a>
              <a href="https://www.douyin.com/user/MS4wLjABAAAAjOsLv8o28bYbKOPCcncREobBQ6wvEjANdOgNOeszQDA"
                target="blank" class="items-center justify-center">
                <img src="@/assets/images/dy.png" style="width: 22px;height: 22px;opacity: 0.7;">
              </a>
            </div>
            <div class="line"></div>
            <div class="copyright">
              Copyright © Golden Bridge Corp. All rights reserved.
            </div>
            <div class="support">
              技术支持：台商匯信息科技有限公司
            </div>
            <div class="logo-bottom">
              <img src="@/assets/images/logo.png" style="width:52px;height:36px;">
            </div>
          </div>

        </el-drawer>
      </div>
      <!-- 登录框 -->
      <el-dialog v-if="dialogVisible" :class="['login-pop', { 'login-pop-big': step == 1 }]"
        :visible.sync="dialogVisible" :before-close="handleClose">
        <div class="login-top" slot="title">
          <!-- <div class="logo-title justify-center items-end">
          <img src="@/assets/images/logow.png" style="width:100px;height:70px;">
          <h3>台商雜誌</h3>
        </div> -->
          <h4 v-if="step == 1">會員登入</h4>
          <h4 v-if="step == 2">會員註冊</h4>
          <h4 v-if="step == 3">忘記密碼</h4>
        </div>
        <div class="login-container">
          <div class="login-inp flex-col items-center" v-if="step == 1">
            <div class="login-inp-content flex-row justify-between">
              <div class="login-inp-content-left">
                <el-input class="login-inp-content-left-input" placeholder="電子郵件" v-model="loginRes.email">
                  <!-- <svg-icon slot="suffix" icon-class="black-envelope"></svg-icon> -->
                </el-input>
                <el-input class="login-inp-content-left-input" placeholder="密碼" :type="!showPassword ? 'password' : 'text'"
                  v-model="loginRes.password">
                  <svg-icon v-if="!showPassword" slot="suffix" icon-class="eyes-close"
                    @click="showPassword = !showPassword"></svg-icon>
                  <svg-icon v-else slot="suffix" icon-class="eyes-open"
                    @click="showPassword = !showPassword"></svg-icon>
                </el-input>
                <button class="submit" @click="fnToLogin">立即登入</button>
                <p style="margin-top: 12px">
                  我曾經註冊過，但我<a style="color: #2C2C2E;" href="#" @click="step = 3">忘記密碼</a>
                </p>
              </div>
              <span class="or">或</span>
              <!-- <span>使用社群帳號登入</span> -->
              <div class="login-inp-content-right">
                <button class="btn bg-blue items-center justify-center" @click="authToLogin('facebook')">
                  <svg-icon slot="suffix" icon-class="facebook" color="#fff"></svg-icon>
                  Facebook 登入
                </button>
                <button class="btn bg-red3 items-center justify-center" @click="authToLogin('google')">
                  <svg-icon slot="suffix" icon-class="google" color="#fff"></svg-icon>
                  Google 登入
                </button>
                <!-- <button
            class="btn bg-red3 items-center justify-center"
            @click="logout"
          >
            退出登錄
          </button> -->
                <p style="margin-top: 39px">
                  還不是會員? <a href="#" @click="step = 2">立即註冊</a>
                </p>
              </div>
            </div>
            <a class="privacy" href="#">隱私權條款</a>
          </div>
          <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="auto" class="demo-dynamic"
            :rules="rules">
            <div class="login-inp register-inp flex-col items-center" v-if="step == 2">
              <el-form-item prop="email" :rules="[
                { required: true, message: '請輸入電子郵箱', trigger: 'blur' },
                {
                  type: 'email',
                  message: '請輸入正確的電子郵箱',
                  trigger: ['blur', 'change'],
                },
              ]">
                <el-input placeholder="電子郵件" v-model="dynamicValidateForm.email">
                  <!-- <svg-icon slot="suffix" icon-class="black-envelope"></svg-icon> -->
                </el-input>
              </el-form-item>

              <el-form-item prop="code">
                <div class="code justify-between items-center">
                  <el-input placeholder="驗證碼" v-model="dynamicValidateForm.code">
                    <!-- <svg-icon slot="suffix" icon-class="yzm"></svg-icon> -->
                  </el-input>
                  <button @click="getCode" :disabled="!forbiddenSend" :class="[
                    {
                      ['btn-disable']: !forbiddenSend,
                    },
                  ]">
                    {{ countdown ? countdown + "後重識" : "獲取驗證碼" }}
                  </button>
                </div>
              </el-form-item>
              <el-form-item prop="pass">
                <el-input :type="!showPassword ? 'password' : 'text'" placeholder="密碼" autocomplete="off"
                  v-model="dynamicValidateForm.pass">
                  <svg-icon v-if="!showPassword" slot="suffix" icon-class="eyes-close" color="#AEAEB2"
                    @click="showPassword = !showPassword"></svg-icon>
                  <svg-icon v-else slot="suffix" icon-class="eyes-open" color="#AEAEB2"
                    @click="showPassword = !showPassword"></svg-icon>
                </el-input>
              </el-form-item>
              <button class="submit" @click="toRegister">加入會員</button>
              <!-- <span>或</span>
            <span>使用社群帳號登入</span>
            <button class="btn bg-blue items-center justify-center" @click="authToLogin('facebook')">
              <svg-icon slot="suffix" icon-class="Path 434"></svg-icon>
              Facebook 登入
            </button>
            <button class="btn bg-red3 items-center justify-center" @click="authToLogin('google')">
              <svg-icon slot="suffix" icon-class="Path 436"></svg-icon>
              Google 登入
            </button> -->
              <p>
                我已經註冊過，
                <a class="text-red2" href="#" @click="step = 1">直接登入</a>
              </p>
              <a class="privacy" href="#">隱私權條款</a>
            </div>
          </el-form>
          <el-form :model="dynamicValidateForm2" ref="dynamicValidateForm2" label-width="auto" class="demo-dynamic"
            :rules="rules2">
            <div class="login-inp register-inp flex-col items-center" v-if="step == 3">
              <el-form-item prop="email" :rules="[
                { required: true, message: '請輸入電子郵箱', trigger: 'blur' },
                {
                  type: 'email',
                  message: '請輸入正確的電子郵箱',
                  trigger: ['blur', 'change'],
                },
              ]">
                <el-input placeholder="電子郵件" v-model="dynamicValidateForm2.email">
                  <svg-icon slot="suffix" icon-class="black-envelope"></svg-icon>
                </el-input>
              </el-form-item>
              <el-form-item prop="code">
                <div class="code justify-between items-center">
                  <el-input placeholder="驗證碼" v-model="dynamicValidateForm2.code">
                    <!-- <svg-icon slot="suffix" icon-class="yzm"></svg-icon> -->
                  </el-input>
                  <button @click="getCode2" :disabled="!forbiddenSend" :class="[
                    {
                      ['btn-disable']: !forbiddenSend,
                    },
                  ]">
                    {{ countdown ? countdown + "後重識" : "獲取驗證碼" }}
                  </button>
                </div>
              </el-form-item>
              <el-form-item prop="pass">
                <el-input :type="!showPassword ? 'password' : 'text'" placeholder="重設密碼" autocomplete="off"
                  v-model="dynamicValidateForm2.pass">
                  <svg-icon v-if="!showPassword" slot="suffix" icon-class="eyes-close"
                    @click="showPassword = !showPassword"></svg-icon>
                  <svg-icon v-else slot="suffix" icon-class="eyes-open"
                    @click="showPassword = !showPassword"></svg-icon>
                </el-input>
              </el-form-item>
              <button class="submit" @click="confirmPw">確認</button>
              <!-- <button class="submit" v-else @click="getCode">確認</button> -->

              <p style="margin-top: 15px">
                還不是會員？
                <a class="text-red2" href="#" @click="step = 2">立即註冊</a>
              </p>
              <a class="privacy" href="#">隱私權條款</a>
            </div>
          </el-form>
        </div>
        <img src="@/assets/images/logo-grey.png" alt="" class="logo-grey">
      </el-dialog>
      <search-pop ref="searchPop"></search-pop>
      <div id="fb-root"></div>
    </div>
  </div>

</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { mapState, mapActions } from "vuex";
import { getNewsList } from "@/assets/api/news.js";
import {
  getEmailCode,
  register,
  forgetPw,
  login,
  otherLogin,
} from "@/assets/api/login.js";
import searchPop from "@/views/common/search-pop.vue";
export default {
  components: {
    swiper,
    swiperSlide,
    searchPop,
  },
  data() {
    var checkCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("驗證碼不能為空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(value) && value.length != 6) {
          callback(new Error("請輸入正確的驗證碼！"));
        } else {
          callback();
        }
      }, 1000);
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("請輸入密碼"));
      } else {
        callback();
      }
    };

    var validatePass3 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("請輸入密碼"));
      } else {

        callback();
      }
    };
    return {
      showPassword: false,
      swiperOption: {
        direction: "vertical",
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 3000, //自动切换的时间间隔
          pauseOnMouseEnter: true, //鼠标置于swiper时暂停自动切换，鼠标离开时恢复自动切换。
        },
      },
      navMenu: [
        {
          title: "首頁",
          to: "/",
        },
        {
          title: "雜誌訂閱",
          to: "/magazine",
        },
        {
          title: "智庫專欄",
          to: "/expert",
        },
        {
          title: "經貿動態",
          to: "/article?typeId=16",
        },
        // {
        //   title: "新聞頭條",
        //   to: "/article?typeId=13",
        // },
        {
          title: "故事專訪",
          to: "/story?typeId=14",
        },
        {
          title: "好書推薦",
          to: "/book",
        },
        // {
        //   title: "影音視頻",
        //   to: "/article?typeId=15",
        // },
        // {
        //   title: "政策指引",
        //   to: "/article?typeId=17",
        // },
        // {
        //   title: "生活資訊",
        //   to: "/article?typeId=18",
        // },
        {
          title: "關於我們",
          to: "/about",
        },
      ],
      navMobileMenu: [
        {
          title: "首頁",
          to: "/",
        },
        {
          title: "雜誌訂閱",
          to: "/magazine",
        },
        {
          title: "智庫專欄",
          to: "/expert",
        },
        {
          title: "故事專訪",
          to: "/story?typeId=14",
        },
        {
          title: "好書推薦",
          to: "/book",
        },
        {
          title: "關於我們",
          to: "/about",
        },
        {
          title: "新聞頭條",
          to: "/article?typeId=13",
        },
        {
          title: "影音視頻",
          to: "/video?typeId=15",
        },
        {
          title: "政策指引",
          to: "/article?typeId=17",
        },
        {
          title: "經貿動態",
          to: "/article?typeId=16",
        },
        {
          title: "生活資訊",
          to: "/article?typeId=18",
        },
      ],
      drawer: false,
      step: 1,
      email: "",
      code: "",
      dialogVisible: false,
      forbiddenSend: true, //获取验证码按钮状态
      countdown: "",
      timecountdown: false,
      dynamicValidateForm: {
        email: "",
        code: "",
        pass: "",
      },
      rules: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        code: [{ validator: checkCode, trigger: "blur" }],
      },
      // 忘记密码
      isHasCode: false, //：是否已经获取验证码
      dynamicValidateForm2: {
        email: "",
        code: "",
        pass: "",
      },
      rules2: {
        pass: [{ validator: validatePass3, trigger: "blur" }],
        code: [{ validator: checkCode, trigger: "blur" }],
      },
      loginRes: {
        email: "",
        password: "",
      },
      newsListRes: [],
    };
  },
  computed: {
    ...mapState(["isPc", "validToken", "webInfo", "isDialogVisible", "searchKeyword", "triggerSearch"]),
    onRoutes() {
      // 已改写成只需匹配到一级路由即可匹配菜单
      // console.log(this.$route.matched[1])
      this.drawer = false;
      return this.$route.fullPath;
    },
  },
  watch: {
    isDialogVisible(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$store.state.isDialogVisible = val;
    },
    triggerSearch(newVal) {
      if (newVal) {
        this.toSearch();
        this.$refs.searchPop.searchVisible = true;
        this.$refs.searchPop.keyword = this.searchKeyword;
        this.resetTriggerSearch();
      }
    }
  },
  created() {
    getNewsList({
      orderByColumn: "releaseTime",
      isAsc: "desc",
      pageNum: 1,
      pageSize: 6,
      slideshow: 0,
    }).then((res) => {
      this.newsListRes = res.data.rows;
    });
  },
  methods: {
    ...mapActions(['resetTriggerSearch']),
    changeDrawer() {
      this.drawer = !this.drawer;
      this.$refs.searchPop.searchVisible = false;

    },
    wxMobile() {
      this.$router.push('/wx-mobile');
    },
    toOrder() {
      this.$router.push('/order');

    },
    toSearch() {
      if (!this.$refs.searchPop.searchVisible) {
        this.$refs.searchPop.keyword = '';
      }
      this.$refs.searchPop.searchVisible = !this.$refs.searchPop.searchVisible;
      this.drawer = false;
      // this.$refs.searchPop.keyword = this.searchKeyword;

      // this.resetTriggerSearch();
    },
    verifiCodeSended() {
      var vm = this;
      vm.forbiddenSend = false;
      vm.step = 2;
      var time = new Date();
      var timer = setInterval(() => {
        var newTime = new Date();
        var lastTime = 60 - Math.floor((newTime - time) / 1000);
        if (lastTime <= 0) {
          clearInterval(timer);
          vm.countdown = "";
          vm.forbiddenSend = true;
          vm.timecountdown = false;
          // console.log("clearInterval",!vm.phoneNumIsValid && !vm.forbiddenSend);
        } else {
          vm.countdown = lastTime + "s";
          vm.timecountdown = true;
          vm.forbiddenSend = false;
        }
      }, 1000);
    },
    getCode() {
      // if (this.dynamicValidateForm.code !== "") {
      // this.$refs.dynamicValidateForm.validateField("email");
      // }
      this.$refs["dynamicValidateForm"].validateField(["email"], (valid) => {
        if (!valid) {
          // alert("submit!");
          console.log(valid);
          getEmailCode({
            email: this.dynamicValidateForm.email,
          }).then((res) => {
            this.verifiCodeSended();
            this.$message({
              message: "發送成功",
              type: "success",
            });
            console.log(res);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getCode2() {
      // if (this.dynamicValidateForm.code !== "") {
      // this.$refs.dynamicValidateForm.validateField("email");
      // }
      this.$refs["dynamicValidateForm2"].validateField(["email"], (valid) => {
        if (!valid) {
          // alert("submit!");
          console.log(valid);
          getEmailCode({
            email: this.dynamicValidateForm2.email,
          }).then((res) => {
            this.verifiCodeSended2();
            this.$message({
              message: "發送成功",
              type: "success",
            });
            console.log(res);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    verifiCodeSended2() {
      var vm = this;
      vm.forbiddenSend = false;
      vm.step = 3;
      var time = new Date();
      var timer = setInterval(() => {
        var newTime = new Date();
        var lastTime = 60 - Math.floor((newTime - time) / 1000);
        if (lastTime <= 0) {
          clearInterval(timer);
          vm.countdown = "";
          vm.forbiddenSend = true;
          vm.timecountdown = false;
          // console.log("clearInterval",!vm.phoneNumIsValid && !vm.forbiddenSend);
        } else {
          vm.countdown = lastTime + "s";
          vm.timecountdown = true;
          vm.forbiddenSend = false;
        }
      }, 1000);
    },
    confirmPw() {
      this.$refs["dynamicValidateForm2"].validate((valid) => {
        console.log(valid);

        if (valid) {
          // alert("submit!");
          console.log(valid);
          forgetPw({
            loginName: this.dynamicValidateForm2.email,
            password: this.dynamicValidateForm2.pass,
            code: this.dynamicValidateForm2.code,
          }).then((res) => {
            if (res.data.code != 500) {
              this.$message({
                message: "重置成功，請登錄",
                type: "success",
              });
              this.step = 1;
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            console.log(res);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    toRegister() {
      this.$refs["dynamicValidateForm"].validate((valid) => {
        if (valid) {
          // alert("submit!");
          console.log(valid);
          register({
            loginName: this.dynamicValidateForm.email,
            password: this.dynamicValidateForm.pass,
            code: this.dynamicValidateForm.code,
          }).then((res) => {
            if (res.data.code != 500) {
              this.$message({
                message: "註冊成功，請登錄",
                type: "success",
              });
              this.step = 1;
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            console.log(res);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    fnToLogin() {
      login({
        loginName: this.loginRes.email,
        password: this.loginRes.password,
      }).then((res) => {
        if (res.data.code == 500) {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        } else {
          this.$message({
            message: "登錄成功",
            type: "success",
          });
          this.dialogVisible = false;
          this.$store.state.isDialogVisible = false;
          this.$store.dispatch("checkToken");
          window.sessionStorage.setItem("token", res.data.data);
          location.reload();
        }

        console.log(res.data.data);
      });
    },
    login() {
      FB.login(function (response) {
        console.log(response);
        if (response.status === "connected") {
          // Logged into your webpage and Facebook.
        } else {
          // The person is not logged into your webpage or we are unable to tell.
        }
      });
    },
    logout() {
      window.sessionStorage.setItem("token", "");
      this.$store.dispatch("checkToken");
      location.reload();
      this.$router.push({
        path: `/`,
      });
    },
    authToLogin(type) {
      otherLogin(type).then((res) => {
        console.log(res);
        window.open(res.data.data, "_self");
      });
    },
    toMyCenter(type) {
      this.drawer = false;
      this.$refs.searchPop.searchVisible = false;
      this.$router.push({
        path: `/member-center?type=${type}`,
      });
    },
    toCart() {
      if (!this.validToken) {
        this.$store.state.isDialogVisible = true;
      } else {
        this.$router.push({
          path: `/magazine-cart`,
        });
      }
    },
    // toDetails(newsId, url) {
    //   if (url) {
    //     window.open(url, "_blank");
    //   } else {
    //     this.$router.push({
    //       path: `/article-details/${newsId}`,
    //     });
    //   }
    // },
    handleSelect(key, keyPath) {
      this.drawer = false;
      this.$router.push({
        path: key,
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.hot {
  width: 30px;
  height: 30px;
}

.header-container {
  position: relative;
  height: 120px;
}

.header {
  border-bottom: 1px solid #E5E5EA;
  background-color: #fff;
  position: fixed;
  z-index: 2001;

  .menu {
    padding: 25px 0;
    //   position: fixed;
    //   top: 0;
    //   left: 0;
    //   right: 0;
    //   z-index: 2001;
    // background-color: #fff;


    // padding: 0 80px;
    a {
      font-size: 0;
    }

    img {
      width: 104px;
      height: 72px;
      cursor: pointer;
      object-fit: contain;
    }

    .login-btn {
      width: 96px;
      height: 50px;
      background: #FFFFFF;
      border-radius: 25px;
      border: 1px solid #E5E5EA;
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: bold;
      font-size: 16px;
      color: #2C2C2E;
      line-height: 21px;
      text-align: center;
      font-style: normal;
      cursor: pointer;
    }

    .login-btn:hover {
      background: #E2291E;
      color: #fff;
      border: 1px solid #E2291E;
    }

    .svg-icon {
      width: 26px;
      height: 26px;
      margin-right: 22px;
      cursor: pointer;
    }
  }

  .swiper-container {
    height: 20px;
    margin: 0;
  }
}

.header {
  .el-menu {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .el-menu.el-menu--horizontal {
    border-bottom: none;
  }

  .el-menu--horizontal>.el-menu-item {
    font-family: MicrosoftYaHei;
    font-size: 18px;
    color: #2C2C2E;
    line-height: 24px;
    letter-spacing: 1px;
    text-align: center;
    font-style: normal;
    display: flex;
    align-items: center;
    height: auto;
    padding: 5px 30px;
    border-bottom: none;
    background-color: #fff !important;

    span {
      display: flex;
      align-items: center;
    }

    &:hover {
      color: #E2291E !important;
    }

  }

  .el-menu::after,
  .el-menu::before {
    content: none;
  }

  .link-list {
    margin-left: -30px;
    position: relative;
    z-index: 100;

    .svg-icon {
      width: 21px;
      height: 21px;
      margin-left: 9px;
      margin-right: 0;
      cursor: pointer;
      fill: #f00;
    }
  }

  .info-list {
    padding: 8px 0;

    .tag {
      margin: 0 12.1px 0 0;
    }

    span {
      padding: 0 2px 0 7px;
    }

    .tag::after {
      content: "";
      width: 0;
      height: 0;
      border: 10px solid;
      border-color: transparent transparent transparent #fff;
      display: block;
    }
  }
}

@media screen and (max-width: 768px) {
  .header-container {
    height: 60px;
  }

  .header {
    .menu {
      padding: 0;
    }

    padding: 10px 20px;

    .logo-title {
      position: static;

      h3 {
        padding: 2.1px 8.6px 3.5px 3.7px;
        border-radius: 3px;
        background-image: linear-gradient(116deg, #dc000c -2%, #080101 151%);
        font-family: ToppanBunkyuMidashiMincho;
        font-size: 13px;
        font-weight: 800;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: 1.56px;
        text-align: left;
        color: #fff;
        margin-left: 2px;
        margin-top: 3px;
      }

      .svg-icon {
        width: 50px;
        height: 40px;
        position: relative;
        top: 0;
      }
    }

    .icons {
      .magazine-card {
        width: 96px;
        height: 40px;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 19px;
        text-align: center;
        font-style: normal;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
      }

      .magazine-card::before {
        content: "";
        width: 96px;
        height: 40px;
        border-radius: 25px;
        background-image: linear-gradient(var(--rotate), #B839CC, #2E3B85, #3CD5DE, );
        position: absolute;
        // z-index: -1;
        top: 0;
        left: 0;
        animation: spin 5s linear infinite;
      }


      @keyframes spin {
        0% {
          --rotate: 0deg;
        }

        100% {
          --rotate: 360deg;
        }
      }

      .magazine-card-content {
        background: #191c29;
        width: 90px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        border-radius: 25px;
      }

      .svg-icon {
        width: 18px;
        height: 18px;
        margin-right: 0;
      }

      .btn {
        position: relative;
        cursor: pointer;

        .svg-icon {
          width: 18px;
          height: 18px;
          margin-right: 20px;
        }

        span {
          font-family: MicrosoftYaHei, MicrosoftYaHei;
          font-weight: bold;
          font-size: 14px;
          color: #2C2C2E;
          line-height: 19px;
          text-align: center;
          font-style: normal;
          background: #FFFFFF;
          border-radius: 25px;
          border: 1px solid #E5E5EA;
          padding: 5px 10px;
          margin-right: 20px;
        }
      }

      .btn-maz {
        // width: 40px;
        // height: 40px;
        margin-right: 20px;

        .svg-icon {
          width: 20px;
          height: 20px;
          // padding: 10px;
          box-sizing: content-box;
        }
      }
    }

    .info-list {
      padding: 8px 10px;

      .tag {
        margin: 0;
        font-family: NotoSansCJKTC;
        font-size: 12px;
        font-weight: bold;
        white-space: nowrap;
        line-height: 18px;
      }

      span {
        padding: 0 1px 0 5px;
      }

      .tag::after {
        content: "";
        width: 0;
        height: 0;
        border: 9px solid;
        border-color: transparent transparent transparent #fff;
        display: block;
      }

      .info-list-item {
        font-family: NotoSansCJKTC;
        font-size: 10px;
        font-weight: bold;
        letter-spacing: 1px;
        height: 17px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }

  .menu-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;

    // padding: 0 20px;
    h4 {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #636366;
      line-height: 19px;
      text-align: center;
      font-style: normal;
    }

  }

  .menu-bottom .line {
    width: auto;
    height: 1px;
    background: #E5E5EA;
    margin: 20px;
  }

  .share {
    // position: absolute;
    // bottom: 20px;
    width: 60%;
    margin: 20px auto;
    // left: 50%;
    // transform: translateX(-50%);
  }

  .share .svg-icon {
    width: 30px;
    height: 30px;
  }

  .menu-bottom .logo-bottom {
    // position: absolute;
    // right: 0;
    // bottom: 0;
    width: 100%;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #E2291E;
    margin-top: 20px;

  }

  .menu-bottom .copyright,
  .menu-bottom .support {
    font-family: MicrosoftYaHei;
    font-size: 12px;
    color: #AEAEB2;
    line-height: 16px;
    text-align: center;
    font-style: normal;
    margin-top: 8px;
  }
}
</style>
<style>
.el-popover {
  min-width: 120px;
  padding: 6px;
  background: #FFFFFF;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.2);
  border-radius: 16px;
  border: 1px solid #E5E5EA;
}

.my-center-popover-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.my-center-popover-item {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-radius: 12px;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #2C2C2E;
  line-height: 19px;
  text-align: center;
  font-style: normal;
  cursor: pointer;
}

.my-center-popover-item:hover {
  background: #E2291E;
  color: #fff;
}

.login-pop .el-dialog {
  width: 400px;
  /* max-width: 430px; */
  margin: 0 auto !important;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 16px;
  overflow: hidden;
}

.login-pop .el-dialog__header {
  padding: 50px 0 0;
}

.login-pop-big .el-dialog {
  width: 800px;
}

.login-top h4 {
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-weight: bold;
  font-size: 18px;
  color: #2C2C2E;
  line-height: 24px;
  text-align: center;
  font-style: normal;
}

.el-dialog__headerbtn .el-dialog__close {
  color: #2C2C2E;
  font-weight: bold;
  font-size: 24px;
}

.el-dialog__headerbtn .el-dialog__close:hover {
  color: #E2291E;
}

.el-dialog__body {
  padding: 20px 50px;
}

.login-container .el-input__suffix {
  font-family: NotoSansCJKTC;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #595757;
  display: flex;
  align-items: center;
  margin-right: 20px;
  cursor: pointer;
}

.login-container .el-input__suffix .svg-icon {
  width: 20px !important;
  height: 20px !important;
  display: block;
}

.login-container p {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #AEAEB2;
  line-height: 19px;
  text-align: center;
  font-style: normal;
  margin-top: 16px;
}

.login-container a {
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-weight: bold;
  font-size: 14px;
  color: #E2291E;
  line-height: 19px;
  text-align: center;
  font-style: normal;
  /* text-decoration: underline; */
}

.login-container .privacy {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #AEAEB2;
  line-height: 19px;
  text-align: left;
  font-style: normal;
  margin-top: 30px;
}

.login-inp .login-inp-content-left-input {
  margin-bottom: 16px;
  padding: 15px 20px;
  background-color: #fff;
  display: flex;
  align-items: center;
  background: #FFFFFF;
  border-radius: 30px;
  border: 1px solid #E5E5EA;
}

.login-container .el-form-item__content {
  padding: 5px 5px 5px 20px;

}

.login-inp .el-input__inner {
  padding: 0;
  border: none;
  margin: 0;
  height: auto;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #2C2C2E;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}

.login-inp-content {
  width: 100%;
}

.login-inp-content-left {
  width: 43%;
}

.login-inp-content-right {
  width: 43%;
}

.register-inp .el-input {
  margin-top: 0;
}

.register-inp .el-form-item {
  margin-bottom: 16px;
  width: 100%;
  background: #FFFFFF;
  border-radius: 30px;
  border: 1px solid #E5E5EA;
  overflow: hidden;
}

/* .el-input__prefix,
.el-input__suffix {
  position: static;
} */
.el-input__suffix .svg-icon {
  width: 18px !important;
  height: 18px !important;
  display: block;
}

.submit {
  cursor: pointer;
  width: 100%;
  margin-top: 4px;
  padding: 14px 0;
  background: #E2291E;
  border-radius: 25px;
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-weight: bold;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 21px;
  text-align: center;
  font-style: normal;
  border: none;
}

.login-inp .btn {
  cursor: pointer;
  width: 100%;
  border-radius: 25px;
  border: none;
  padding: 14px 0;
  margin-bottom: 16px;
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-weight: bold;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 22px;
  text-align: center;
  font-style: normal;
  position: relative;
}

.or {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #AEAEB2;
  line-height: 19px;
  text-align: center;
  font-style: normal;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.or::before,
.or::after {
  content: "";
  display: inline-block;
  width: 1px;
  height: 50px;
  background: #E5E5EA;
  margin: 10px 0;
}

.login-inp .btn .svg-icon {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 10px;
  top: 10px;
}

.logo-grey {
  width: 210px;
  height: 210px;
  position: absolute;
  bottom: -31px;
  right: -22px;
}

.el-drawer {
  width: 100% !important;
  height: 70% !important;
  /* background-color: #dc000c; */
}

.el-drawer__wrapper {
  top: 97px;
}

.el-drawer__header {
  display: none;
}

.el-drawer .el-menu {
  border-right: none;
  padding-top: 40px;
}

.el-drawer .el-menu-item {
  padding: 0 !important;
  border-bottom: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #2C2C2E;
  line-height: 19px;
  text-align: center;
  font-style: normal;
  cursor: pointer;
  height: 24px;
  margin-bottom: 20px;



}

.el-drawer .el-menu-item span {
  width: 100%;
}

.el-drawer .el-menu-item .border-side {
  border-left: 1px solid #E5E5EA;
  border-right: 1px solid #E5E5EA;
}

.el-drawer .el-menu-item.is-active {
  border-bottom: none;
  color: #E2291E;
}

.el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: none;
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-weight: bold;
  font-size: 18px;
  color: #2C2C2E;
  line-height: 24px;
  letter-spacing: 1px;
  text-align: center;
  font-style: normal;
  background-color: #fff;
}

.el-menu--horizontal>.el-menu-item:hover {
  color: #2C2C2E;
  background-color: #fff !important;
}

.code {
  width: 100%;
}

.code .el-input {
  margin-top: 0;
}

.code button {
  min-width: 102px;
  height: 40px;
  background: #F2F2F7;
  border-radius: 25px;
  cursor: pointer;
  border: none;
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-weight: bold;
  font-size: 14px;
  color: #2C2C2E;
  line-height: 19px;
  text-align: center;
  font-style: normal;
  margin-right: 5px;
}

.code button.btn-disable {
  background: rgba(34, 34, 34, 0.28);
}

.login-container {
  position: relative;
  z-index: 9;
}

.login-container .el-input__suffix {
  margin-top: 0;
}

@media screen and (max-width: 768px) {
  .el-drawer__wrapper {
    top: 61px;
  }

  .login-pop .el-dialog__header {
    padding: 20px 0 8px;
  }

  .login-top h4 {
    margin-top: 0px;
    line-height: 33px;
  }

  .el-dialog__header .login-top .logo-title .svg-icon {
    width: 80px;
    height: 60px;
  }

  .el-dialog__header .login-top .logo-title h3 {
    font-family: ToppanBunkyuMidashiMincho;
    font-size: 22px;
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 2.64px;
    text-align: left;
    color: #fff;
    padding: 3.5px 10.6px 5.2px 6.2px;
    border-radius: 3px;
    background-image: linear-gradient(116deg, #dc000c -2%, #080101 151%);
    position: relative;
    top: -4px;
  }

  .el-dialog__headerbtn {
    top: 20px;
    right: 20px;
  }

  .el-dialog__headerbtn .el-dialog__close {
    font-size: 24px;
  }

  .el-dialog__body {
    padding: 20px 45px;
  }

  .login-top h4 {
    margin-top: 60px;
  }

  .login-pop-big .el-dialog {
    width: 100%;
    height: calc(100vh - 60px);
    border-radius: 0;
    top: 60px;
    transform: none;
  }

  .login-inp-content {
    flex-direction: column !important;
  }

  .login-inp-content-left {
    width: 100%;
  }

  .login-inp-content-right {
    width: 100%;
  }

  .or {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
    margin-top: 40px;
  }

  .or::before,
  .or::after {
    width: 44%;
    height: 1px;
  }

  .login-container .privacy {
    margin-top: 100px;
  }

  .login-pop .el-dialog {
    width: 100%;
    height: calc(100vh - 60px);
    border-radius: 0;
    top: 60px;
    transform: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/common/Header.vue